import * as React from 'react';
import { useEffect } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';

import { theme } from './theme';
import ResponsiveAppBar from './components/AppBar';
import CoverBlock from './components/CoverBlock';
import AboutMe from './components/AboutMe';
import ExperienceBlock from './components/experienceBlock';
import SkillsBlock from './components/skillsBlock';
import Footer from './components/Footer';
import data from './data.json';

export default function App() {
  const [appBarHeight, setAppBarHeight] = React.useState(0);
  const mainRef = React.useRef(null);
  const aboutMeRef = React.useRef(null);

  const experienceBlockRef = React.useRef(null);
  const skillsBlockRef = React.useRef(null);

  useEffect(() => {
    setAppBarHeight(document.getElementById('app-bar').clientHeight);
  }, []);

  useEffect(() => {
    mainRef.current.style.minHeight = `calc(100vh - ${appBarHeight}px)`;
  }, [appBarHeight]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <main ref={mainRef}>
        {/* App Bar */}
        <ResponsiveAppBar
          aboutMeRef={aboutMeRef}
          experienceBlockRef={experienceBlockRef}
          skillsBlockRef={skillsBlockRef}
        >
        </ResponsiveAppBar>

        {/* Hero unit */}
        <CoverBlock></CoverBlock>

        {/* About Me */}
        <AboutMe ref={aboutMeRef} data={data}></AboutMe>

        {/* Experience */}
        <ExperienceBlock ref={experienceBlockRef} data={data}></ExperienceBlock>

        {/* Skills */}
        <SkillsBlock ref={skillsBlockRef} data={data}></SkillsBlock>

      </main>
      <Footer></Footer>

    </ThemeProvider>
  );
}
